var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":"","width":"100%"}})]),_c('router-view'),_c('footerBot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }